module.exports = __webpack_public_path__ + "static/img/map1.0f15c83.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map1.png
// module id = gCT+
// module chunks = 1